<div class="bulletin-wrapper"
     [ngClass]="{'fade-out':fade}"
     *ngIf="display"
     [ngStyle]="{'background-color': getBackgroundColor()}">
     <div class="messageBuffer"></div>
    <div class="bulletin-message">
        {{obj['message']}}
    </div>
    <div *ngIf="dismissible" class="bulletin-dismiss" [ngStyle]="{'background-color': getBackgroundColor()}">
        <button mat-button (click)="dismiss()" class="bulletin-dismiss-button">
            <mat-icon class="bulletin-dismiss-icon">close</mat-icon>
        </button>
    </div>
</div>